// extracted by mini-css-extract-plugin
export default {"container":"overlap_container__kKIpK","element1":"overlap_element1__Yn2mo","element2":"overlap_element2__PSSYk"};